export const privacyPolicyEnTranslations = {
  privacy_policy: 'Privacy Policy',
  last_updated: 'Last Updated',
  privacy_policy_date: 'November 23, 2025',
  go_back: 'Go Back',
  privacy_policy_content: {
    company_name: 'Intera-AI',
    system_name: 'Intera - Internal Relationship Management',
    introduction: {
      title: 'Introduction',
      welcome:
        'Welcome to the Intera system ("the System") of Intera-AI Ltd. ("the Company").',
      terms:
        'The use of the System is subject to the terms of use of the System and this privacy policy which is part of them.',
      important_notice:
        'Please read this privacy policy and the terms of use of the System carefully before using it, as they constitute a binding contract between you and the Company and your use of the System indicates your agreement to them.',
      updates_notice:
        'Please also return and read them from time to time because their terms may change (we will take care to update in the header of this privacy policy and terms of use the date of the last update made to them).',
      agreement_notice:
        'If you do not agree to the terms of this privacy policy, you must refrain from any use of the System.',
    },
    information_collection: {
      title: 'Provision and Collection of Personal Information',
      system_access: {
        title: 'System Access',
        content: 'Access to the System is made through user accounts.',
      },
      user_accounts: {
        title:
          'User accounts are allocated by the organization in which the users work:',
        admin_user:
          'An administrative user on behalf of the organization that contracted with the Company ("administrative user") is the one who determines (according to the number of licenses purchased by the organization) which user accounts will be established, the organizational affiliation and the usage permissions of each user.',
        account_management:
          'Deletion, addition or modification of user permissions are made by an administrative user, through management tools in the System or by providing instructions to the Company.',
        required_info:
          'For the purpose of establishing an account, the organization provides the Company with first and last name, email address, mobile phone number, department, sub-department, position and direct manager.',
        profile_photos:
          'Users can, if they so wish, upload a photo to their personal profile in the System.',
      },
      admin_permissions:
        'The administrative user has access permissions that allow them to see system access and usage made by users in the System, without the ability to see the content of the usage, unless the user shared the content with the administrative user.',
      direct_manager:
        'A user who has been defined (by the administrative user) as the direct manager of other users has the ability to see actions performed by users for whom they are defined as the direct manager.',
      content_monitoring:
        'The Company does not track users and monitors content that users upload to the System.',
      usage_data:
        'The Company collects information regarding the use of the System in an aggregate or statistical manner (without identifying information) for the purpose of operating and improving the System.',
      security_data:
        'The Company collects information regarding access and access attempts to the System and use of the System for security purposes and enforcement of terms of use.',
    },
    information_usage: {
      title: 'Use of Information',
      intro:
        'The Company will use the information held by it for the following purposes:',
      system_provision: 'Provision of the System.',
      user_support:
        'Responding to user inquiries, including administrative users and representatives of the organization that contracted with it for use of the System.',
      statistics:
        'For statistical and other uses that are not identified with you (such as: improving the System, adding content and tools, changes, etc.).',
      legal_compliance:
        'Compliance with the provisions of law, regulations and regulation.',
      legal_procedures:
        'Managing legal proceedings and clarifying matters, claims and demands that may lead to legal proceedings.',
      fraud_prevention:
        'Prevention of fraud, prevention of bodily harm or property damage.',
      security:
        'Security, prevention, clarification and dealing with security incidents and cyber incidents.',
    },
    information_sharing: {
      title:
        'Provision of Information to Company Suppliers for the Purpose of Service Provision and Information Transfer',
      suppliers:
        "Provision of information to the Company's suppliers or companies related to the Company will be done solely for the purpose of providing the System and while those parties are obligated to maintain confidentiality and use the information only for the purpose of providing the services.",
      data_transfer: {
        title: 'Information Transfer',
        no_sale:
          'The Company does not sell or rent personal information to third parties.',
        no_transfer:
          'The Company will not transfer personal information to third parties without the consent of the data subjects, except: in the cases detailed below:',
        admin_instructions:
          'In accordance with the instructions of the administrative user.',
        legal_requirements:
          'Compliance with legal requirements (law including regulatory provisions and guidelines).',
        court_orders:
          'Compliance with a judicial order, instruction or order from a competent authority.',
        business_reorganization:
          'In the framework of reorganization, sale of shares or investment activity in the Company and in proximity to contracting for any of the aforementioned purposes.',
        legal_proceedings:
          'For the purpose of legal or administrative proceedings.',
        harm_prevention:
          'Insofar as the Company believes that disclosure may help prevent harm to you or others.',
        affiliated_companies:
          "To parent companies, subsidiaries, companies related to the Company in the framework of merger or reorganization of the Company's activities and related companies.",
      },
    },
    user_rights: {
      title: 'Review, Correction and Objection',
      access_requests:
        "Requests for review of information, its correction or deletion should be made to the administrative user or the organization's representative.",
      company_response:
        'Since the Company holds personal information on behalf of the organization for the purpose of providing the System to its users, the Company will act, in response to requests for review, correction or deletion of information, in accordance with the instructions of the administrative user.',
    },
    information_security: {
      title: 'Information Security',
      content_1:
        'The Company implements physical, logical, organizational and technical security measures that are standard in the industry to prevent unauthorized access, misuse, loss or alteration of information.',
      content_2:
        'Including: access controls and permissions, communication encryption (TLS), event monitoring, backups, periodic penetration testing, password policies and more.',
      content_3:
        'Despite our efforts, no system is completely secure. In the event of a serious security incident that poses a real risk to your privacy, we will act in accordance with the law and update the organization/users as required.',
      content_4:
        'Note: The Company is not currently certified according to ISO 27001 standard, and the absence of this certification does not diminish the security efforts we actually implement.',
    },
    policy_scope: {
      title: 'What Information This Policy Applies To',
      content_1:
        'This policy applies to all use of the System (application, browser, API interfaces, management systems) as well as support requests, mailing or other communication with us.',
      content_2:
        "This policy does not apply to the organization's privacy policy, or to third-party systems/services that the organization operates and integrates itself (such as HR systems, BI tools, etc.).",
    },
    policy_changes: {
      title: 'Changes to This Privacy Policy',
      update_rights:
        'The Company reserves the right to update this privacy policy from time to time.',
      notification:
        'Privacy policy updates will be made with advance notice, unless the update is for the benefit of the user, or in order to adapt the policy to changes that will come in law, in which case the change may be immediate.',
      continued_use:
        'Continued use of the System after a change in privacy policy will indicate agreement to the change, and in any case of disagreement, use of the System must be discontinued.',
    },
    children_minors: {
      title: 'Children and Minors',
      content_1:
        'The service is not intended for children under the age of 13, and we do not intend to knowingly collect information from children of this age.',
      content_2:
        'If we learn that we have collected information from a child under the age of 13 without the required parental/guardian consent, we will delete it as soon as possible. Please contact us if you believe such a case has occurred.',
    },
    ownership_changes: {
      title: 'Ownership Changes and Reorganization',
      content_1:
        'In the event of a merger, acquisition, sale of assets or change of control of the Company, personal information may be transferred to the new entity, subject to its commitment to continue to comply with the terms of this policy or more stringent terms.',
    },
    documentation: {
      title: 'Documentation and Previous Versions',
      content_1:
        'We will maintain documentation of previous policy versions and make it available to the organization upon request.',
      content_2:
        'In case of a conflict between an English version and the Hebrew version, the Hebrew version is binding (unless otherwise agreed in writing with the organization).',
    },
    contact: {
      title: 'Contact Information',
      content_1:
        'For questions, requests or complaints regarding privacy matters, please contact us at team@intera-ai.io. We will respond as soon as possible and no later than the timeframe required by law.',
    },
  },
} as const;
